export { BillingProfileLozenge } from './src/billing-profile-lozenge';
